import React, {Component} from "react"
import Alert from './Alert'

class ErrorAlert extends Component {

  render() {

    const error = this.props.error
    let message = ""
    if (error) {
      if (error.message)
        message = error.message + '\n'
      let errors = []
      if (Array.isArray(error.errors))
        errors = error.errors
      else if (error.errors && Array.isArray(error.errors.errors))
        errors = error.errors.errors


      message += errors.map((e) =>
        `field: ${e.field}\nmessage: ${e.message}\nrejected-value: ${e['rejected-value']}\n\n`)

    }

    return (
      <Alert show={error} message={message}/>
    )
  }
}

export default ErrorAlert



// WEBPACK FOOTER //
// ./src/components/ErrorAlert.js